import { render, staticRenderFns } from "./RankingFlagParts.vue?vue&type=template&id=43dc73dc&scoped=true"
import script from "./RankingFlagParts.vue?vue&type=script&lang=ts"
export * from "./RankingFlagParts.vue?vue&type=script&lang=ts"
import style0 from "./RankingFlagParts.vue?vue&type=style&index=0&id=43dc73dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dc73dc",
  null
  
)

export default component.exports